import React from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/api';
import { BRAND_NAME } from '../branding';
import TwoFactorEnrol from '../components/TwoFactorEnrol';
import { showSuccess } from '../components/ToastNotifications';
import './Login.css';

// Compulsory two-factor setup: App.js renders ONLY this page while the signed-in
// user's twoFactorSetupRequired flag is set — the server also refuses every
// other API call until the authenticator is confirmed.
function TwoFactorSetupRequired({ user, setUser }) {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await logout();
    } catch (err) {
      // best-effort: the session may already be gone
    }
    setUser(null);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-brand">{BRAND_NAME}</div>
        <h1 className="login-title">Set up two-factor authentication</h1>
        <p className="login-subtitle">
          Every CRM account must confirm sign-ins with an authenticator app. This takes about a minute and is required before you can continue.
        </p>

        <TwoFactorEnrol
          onDone={() => {
            showSuccess('Two-factor authentication is on');
            setUser({ ...user, twoFactorEnabled: true, twoFactorSetupRequired: false });
            navigate('/dashboard');
          }}
        />

        <div style={{ textAlign: 'center', marginTop: 'var(--spacing-lg, 16px)' }}>
          <button type="button" className="btn btn-outline btn-small" onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}

export default TwoFactorSetupRequired;
